import Header from '@/comp/Header'

const plugins = {
    install(Vue) {
        Vue.component('Header', Header)
    }
}
export default plugins
